import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import type { SelectCustom } from '@ui/SelectCustom/component'
import type { TravelerSelector, TravelerValues } from '@ui/TravelerSelector/component'

const hasTravelerSelector = document.getElementById('capacity_traveler_selector-travelerselector') !== null

const getCapacitySelect = (): HTMLSelectElement | null => document.getElementById('capacity') as HTMLSelectElement | null

export const getCapacity = (): string => {
  if (!hasTravelerSelector) {
    return getCapacitySelect()?.value ?? ''
  }

  const travelerSelectorEl = document.getElementById('capacity_traveler_selector-travelerselector') as HTMLElement

  if (!travelerSelectorEl) {
    return ''
  }

  const travelerSelector = ElementPropertiesManager.getProperty<TravelerSelector>(travelerSelectorEl, 'travelerSelector')

  if (!travelerSelector) {
    return ''
  }

  return JSON.stringify(travelerSelector.getValues())
}

export const setCapacity = (value: null | string): void => {
  if (!hasTravelerSelector) {
    const capacitySelectEl = getCapacitySelect()

    if (!capacitySelectEl) {
      return
    }

    const selectCustom = ElementPropertiesManager.getProperty<SelectCustom>(capacitySelectEl, 'select')

    if (!selectCustom) {
      capacitySelectEl.value = value ?? ''
      return
    }

    selectCustom.setValues([value ?? ''])

    return
  }

  const values = value !== null ? JSON.parse(value) : null
  const travelerSelectorEl = document.getElementById('capacity_traveler_selector-travelerselector') as HTMLElement

  if (!travelerSelectorEl) {
    return
  }

  const travelerSelector = ElementPropertiesManager.getProperty<TravelerSelector>(travelerSelectorEl, 'travelerSelector')

  if (!travelerSelector) {
    return
  }

  travelerSelector.setValues(values as TravelerValues)
}
